import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ForgotPassword from './../ForgotPassword'

import * as accountActions from '../../ducks/account'

function mapStateToProps(state) {
  return {
    isEmailExisting: state.account.get('isPasswordResetEmailExisting')
  }
}

function mapDispatchToProps(dispatch) {
  const actions = bindActionCreators(accountActions, dispatch)

  return {
    onSendResetPasswordMail: actions.sendPasswordResetMail
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)



// WEBPACK FOOTER //
// ./src/components/smart/ForgotPasswordContainer.js